import React from "react";
import { useHistory } from "react-router-dom";
import { BiWinkSmile } from "react-icons/bi";
import { Container } from "./styles";

function SubmitedForm() {
  const history = useHistory();

  return (
    <Container>
      <div className="message-content">
        <BiWinkSmile className="message-img" />

        <p className="message-text">
          Processo está sendo enviado para o banco de dados
        </p>
      </div>

      <div className="footer-wrapper">
        <div className="circular">
          <div className="inner">
            <div className="number">100%</div>
            <div className="circle">
              <div className="bar left">
                <div className="progress"></div>
              </div>
              <div className="bar right">
                <div className="progress"></div>
              </div>
            </div>
          </div>
        </div>

        <button className="button" onClick={() => history.push("/dashboard")}>
          OK
        </button>
      </div>
    </Container>
  );
}

export default SubmitedForm;
